import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/authService";
import { toast, ToastContainer } from "react-toastify";

import { auth, db } from "../firebaseConfig"; // ✅ adapte si ton fichier est src/firebase.js
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";

// ✅ Optionnel: whitelist email(s) autorisés à être admin automatiquement
const ADMIN_EMAILS = ["admin@togo-fashion.com", "simnonservices@gmail.com"].map((s) =>
  s.toLowerCase().trim()
);

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ crée/merge users/{uid} pour que les règles Storage puissent lire role
  const ensureUserDoc = async () => {
    const u = auth.currentUser;
    if (!u) throw new Error("Utilisateur non connecté");

    const ref = doc(db, "users", u.uid);
    const snap = await getDoc(ref);

    const emailLower = (u.email || "").toLowerCase().trim();

    // si doc existe déjà: on garde son role
    const existingRole = snap.exists() ? snap.data()?.role : null;

    // si pas de doc ou pas de role: on met "admin" si email whitelist, sinon "user"
    const role =
      existingRole ||
      (ADMIN_EMAILS.includes(emailLower) ? "admin" : "user");

    await setDoc(
      ref,
      {
        email: u.email || "",
        role,
        uid: u.uid,
        lastLoginAt: serverTimestamp(),
        createdAt: snap.exists() ? snap.data()?.createdAt || serverTimestamp() : serverTimestamp(),
      },
      { merge: true }
    );

    return role;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      await login(email.trim(), password);

      // ✅ garantit users/{uid} -> role lisible par Storage rules
      const role = await ensureUserDoc();
      console.log("LOGIN UID:", auth.currentUser?.uid, "ROLE:", role);

      toast.success("Connexion réussie");

      // ✅ si tu veux bloquer l'accès admin aux non-admin:
      if (role !== "admin") {
        toast.error("Compte non autorisé (admin requis).");
        navigate("/");
        return;
      }

      navigate("/admin/dashboard");
    } catch (e) {
      toast.error(e?.message || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <ToastContainer position="top-right" />
      <div className="row justify-content-center">
        <div className="col-md-5">
          <div className="card shadow-sm">
            <div className="card-body">
              <h4 className="mb-3">Admin – Connexion</h4>

              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Mot de passe</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>

                <button className="btn btn-primary w-100" disabled={loading}>
                  {loading ? "Connexion..." : "Se connecter"}
                </button>

                <p className="text-muted small mt-3 mb-0">
                  ✅ Après connexion, un document <code>users/{`{uid}`}</code> est créé/ajusté automatiquement.
                  L’accès admin exige <code>role: "admin"</code>.
                </p>
              </form>
            </div>
          </div>

          <div className="text-muted small mt-2">
            Astuce: si tu veux gérer les admins à la main, enlève la whitelist et garde seulement le role existant.
          </div>
        </div>
      </div>
    </div>
  );
}
